import React from "react";
import Skeleton from "@mui/material/Skeleton";
import MDBox from "components/MDBox";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";

export default function FeedLoader() {
  return (
    <MDBox>
      <Card sx={{ border: "1px solid #6a6a6a" }}>
        <CardHeader
          avatar={
            <Skeleton
              sx={{
                bgcolor: "grey.900",
              }}
              variant="circular"
              width={40}
              height={40}
            />
          }
          title={
            <Skeleton
              sx={{
                bgcolor: "grey.900",
              }}
              variant="text"
              // width={300}
            />
          }
        />
        <MDBox sx={{ height: "420px" }}>
          <Skeleton
            sx={{
              bgcolor: "grey.900",
            }}
            height="100%"
            width="100%"
            variant="rectangular"
          />
        </MDBox>

        <CardContent
          sx={{
            paddingTop: 0,
            paddingBottom: 0,
          }}
        >
          <Skeleton
            sx={{
              bgcolor: "grey.900",
            }}
            variant="text"
            width={200}
          />
          <Skeleton
            sx={{
              bgcolor: "grey.900",
            }}
            variant="text"
            width={150}
          />
        </CardContent>
      </Card>
    </MDBox>
  );
}
